import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import type {
  TGetNewHireReportingSummaryRequest,
  TGetNewHireReportingSummaryResponse,
} from "./getNewHireReportingSummary.schema";

export type { INewHireReportingSummaryItem } from "./getNewHireReportingSummary.schema";

export const getNewHireReportingSummary = (axios: IAxiosInstance) => {
  return async (
    params?: TGetNewHireReportingSummaryRequest
  ): Promise<TGetNewHireReportingSummaryResponse> => {
    const response =
      await axios.noRetry.get<TGetNewHireReportingSummaryResponse>(
        `/api/new-hire-reporting/summary`,
        { params }
      );
    return response.data;
  };
};
